module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showResetPasswordForm) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                Login\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                    Brugernavn\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Indtast brugernavn"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input password"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                    Adgangskode\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Indtast adgangskode"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "remember-me"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("\n                        Husk mig\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleResetPasswordForm()
      }
    }
  }, [_vm._v("\n                        Glemt adgangskode?\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("\n                Log ind\n            ")])]) : _c('div', {
    staticClass: "box"
  }, [(!_vm.passwordResetted) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                    Glemt adgangskode\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                        E-mail\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Indtast e-mail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doReset()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_vm._v("\n                    Nulstil adgangskode\n                ")])]) : _c('div', [_vm._v("\n                Vi har nu nulstillet din adgangskode. Du bør have modtaget en e-mail med en midlertidig adgangskode. Når du logger ind næste gang, anbefaler vi, at du ændrer din kode til noget du selv kan huske.\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/proebitda_logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slogan"
  }, [_vm._v("\n                - Garanterede resultater\n            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d8e10d84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8e10d84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/login.vue
// module id = 886
// module chunks = 0